import { defineMessages } from 'react-intl';

/** The copy of the catalog merge (design catalog-merge a1-a6). */
export const mergeMessages = defineMessages({
  menu: { id: 'app.sml.catalog.merge.menu', defaultMessage: 'Merge with another song…' },
  pickTitle: { id: 'app.sml.catalog.merge.pick.title', defaultMessage: 'Which song is “{title}”?' },
  pickLead: {
    id: 'app.sml.catalog.merge.pick.lead',
    defaultMessage: 'Pick the row of the same song. The two rows become one, and nothing you made is lost.',
  },
  pickSearch: { id: 'app.sml.catalog.merge.pick.search', defaultMessage: 'Search your songs' },
  pickLikely: { id: 'app.sml.catalog.merge.pick.likely', defaultMessage: 'Looks like the same song' },
  pickOthers: { id: 'app.sml.catalog.merge.pick.others', defaultMessage: 'Other songs' },
  pickNone: {
    id: 'app.sml.catalog.merge.pick.none',
    defaultMessage: 'This is your only song. There is nothing to merge with.',
  },
  pickNoMatch: { id: 'app.sml.catalog.merge.pick.noMatch', defaultMessage: 'No song matches the search.' },
  pickNext: { id: 'app.sml.catalog.merge.pick.next', defaultMessage: 'Next' },
  pickLoadFailed: { id: 'app.sml.catalog.merge.pick.loadFailed', defaultMessage: 'The songs did not load. Try again.' },
  addedByYou: { id: 'app.sml.catalog.merge.pick.addedByYou', defaultMessage: 'Added by you' },
  confirmTitle: { id: 'app.sml.catalog.merge.confirm.title', defaultMessage: 'Merge “{from}” into “{title}”?' },
  confirmLead: {
    id: 'app.sml.catalog.merge.confirm.lead',
    defaultMessage: '“{title}” stays. It gets the store data of the other row, and “{from}” leaves the catalog.',
  },
  stays: { id: 'app.sml.catalog.merge.confirm.stays', defaultMessage: 'Stays' },
  leaves: { id: 'app.sml.catalog.merge.confirm.leaves', defaultMessage: 'Leaves the catalog' },
  keeps: { id: 'app.sml.catalog.merge.confirm.keeps', defaultMessage: '{title} keeps' },
  keepsLink: { id: 'app.sml.catalog.merge.confirm.keepsLink', defaultMessage: 'Its SmartLink and pre-save page' },
  keepsKit: { id: 'app.sml.catalog.merge.confirm.keepsKit', defaultMessage: 'Its kit, posts, reels and audio' },
  keepsHistory: { id: 'app.sml.catalog.merge.confirm.keepsHistory', defaultMessage: 'Its title, cover and history' },
  gets: { id: 'app.sml.catalog.merge.confirm.gets', defaultMessage: '{title} gets' },
  getsLink: { id: 'app.sml.catalog.merge.confirm.getsLink', defaultMessage: 'The {service} link' },
  getsDate: { id: 'app.sml.catalog.merge.confirm.getsDate', defaultMessage: 'The release date {date}' },
  getsCover: { id: 'app.sml.catalog.merge.confirm.getsCover', defaultMessage: 'Its cover, because {title} has none' },
  getsMade: { id: 'app.sml.catalog.merge.confirm.getsMade', defaultMessage: 'Anything made for {title}' },
  noUndo: { id: 'app.sml.catalog.merge.confirm.noUndo', defaultMessage: 'You cannot undo a merge.' },
  merge: { id: 'app.sml.catalog.merge.confirm.merge', defaultMessage: 'Merge songs' },
  back: { id: 'app.sml.catalog.merge.confirm.back', defaultMessage: 'Back' },
  claimOne: { id: 'app.sml.catalog.merge.claim.one', defaultMessage: 'This looks like “{title}”. Merge?' },
  claimMany: { id: 'app.sml.catalog.merge.claim.many', defaultMessage: 'This looks like a song you have. Merge?' },
  claimLead: {
    id: 'app.sml.catalog.merge.claim.lead',
    defaultMessage: '{title} keeps its SmartLink and kit and gets the store link and the real date.',
  },
  claimMergeWith: { id: 'app.sml.catalog.merge.claim.mergeWith', defaultMessage: 'Merge with {title}' },
  claimMergeWithMany: { id: 'app.sml.catalog.merge.claim.mergeWithMany', defaultMessage: 'Merge with…' },
  claimKeepSeparate: { id: 'app.sml.catalog.merge.claim.keepSeparate', defaultMessage: 'Keep separate' },
  claimedTitle: { id: 'app.sml.catalog.merge.claim.claimed', defaultMessage: '“{title}” is in your catalog' },
  done: { id: 'app.sml.catalog.merge.done', defaultMessage: '“{from}” is now part of “{title}”.' },
  autoDone: { id: 'app.sml.catalog.merge.autoDone', defaultMessage: 'We added it to “{title}”, the song you made.' },
  failed: {
    id: 'app.sml.catalog.merge.failed',
    defaultMessage: 'We could not merge the songs. Nothing changed. Try again.',
  },
  changed: {
    id: 'app.sml.catalog.merge.changed',
    defaultMessage: 'One of these songs changed. Close this window and open the catalog again.',
  },
  close: { id: 'app.sml.catalog.merge.close', defaultMessage: 'Close' },
  tryAgain: { id: 'app.sml.catalog.merge.tryAgain', defaultMessage: 'Try again' },
});
